var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { H5 } from "@irati/ui/src/Headings";
import multiLineEllipsis from "@irati/ui/src/global/css/multiLineEllipsis";
import IconButton from "../styled/IconButton";
var LINES_TO_SHOW = 3;
var LINE_HEIGHT = 21;
export var StyledH5 = styled(H5)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  ", "\n  height: auto;\n  max-height : ", "px;\n"], ["\n  display: inline-block;\n  ", "\n  height: auto;\n  max-height : ", "px;\n"])), multiLineEllipsis(LINES_TO_SHOW, LINE_HEIGHT), (LINES_TO_SHOW * LINE_HEIGHT));
export var StyledIconBtn = styled(IconButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 10px;\n"], ["\n  padding: 10px;\n"])));
var templateObject_1, templateObject_2;
